import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { VolunteeringEngagementsService } from '../volunteering-engagements.service';
import { CompletedEngagementsViewPart } from './completed-engagements/completed-engagements.part';
import { ContactRequestsViewPart } from './contact-requests/contact-requests.part';
import { OpenEngagementsViewPart } from './open-engagements/open-engagements.part';
import { ScheduledFollowUpsViewPart } from './scheduled-follow-ups/scheduled-follow-ups.part';

@Component({
	selector: 'volunteering-engagements-views-part',
	standalone: true,
	imports: [
		ContactRequestsViewPart,
		OpenEngagementsViewPart,
		CompletedEngagementsViewPart,
		ScheduledFollowUpsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-engagements-views.part.html',
})

export class VolunteeringEngagementsViewsPart implements OnInit {

	public service = inject(VolunteeringEngagementsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}